import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { BiomarkLogo } from '../../assets/Images';
import { TailSpin } from 'react-loader-spinner';

const BioMarkLoader = ({ loading }) => {
  if (!loading) return null;
  return (
    <Box
      sx={{
        position: 'fixed',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={BiomarkLogo}
        alt="BioMark Logo"
        width={24}
        height={24}
        style={{
          position: 'absolute',
        }}
      />
      {loading && (
        <TailSpin
          height="40"
          width="40"
          color="#4FBBE2"
          ariaLabel="tail-spin-loading"
          radius="1"
          visible={true}
        />
      )}
    </Box>
  );
};
BioMarkLoader.propTypes = {
  loading: PropTypes.bool.isRequired,
};
export default BioMarkLoader;
